export { PropertyInfo } from './PropertyInfo'
export type { PropertyInfoProps } from './PropertyInfo'
